module.exports = __webpack_public_path__ + "img/antes_despues_21.ae491643.png";